import React from 'react';
import '../../stylesheets/stylesComponents/title.scss';
import { capitalize } from '../../utils/usefulFunctions';
const Title = props => {
    const { children, className, ...restProps } = props;
    return (
        <h3
            className={`title-component text-overflow-ellipsis ${className}`}
            {...restProps}
        >
            {capitalize(children)}
        </h3>
    );
};

export default Title;
